import { TiendaNubeToken } from '../../interfaces';

export const tiendaNubeToken: TiendaNubeToken = {
    access_token: 'token',
    scope: 'scope',
    token_type: 'token_type',
    user_id: 1,
};
